import React, { ReactElement, useCallback, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Chip, Stack } from '@mui/material';
import ColorizeIcon from '@mui/icons-material/Colorize';
import Avatar from '@mui/material/Avatar';
import * as Icons from '@mui/icons-material';
import { ServiceStatusDialog } from '../../ActivityReservations/ServiceStatusDialog';

export const ClickableStatusCell = ({
  props,
}: {
  props: any;
}): ReactElement => {
  const getFieldContent = useCallback(() => {
    if (props.value?.name === undefined) {
      return {
        element: props.value?.id,
        tooltipValue: props.value?.id,
      };
    } else {
      if (props.value?.color && typeof props.value?.color === 'string') {
        return {
          element: (
            <>
              <Chip
                onClick={() => {
                  console.log('xdddddddd');
                }}
                style={{
                  background: `${props.value?.color}`,
                  color: '#fff',
                }}
                icon={
                  <ColorizeIcon
                    fontSize="small"
                    color={'disabled'}
                    sx={{ color: 'white' }}
                  />
                }
                label={`${props.value?.color}`}
              />
            </>
          ),
          tooltipValue: props.value?.color,
        };
      }
      if (
        props.value?.color &&
        typeof props.value?.color === 'object' &&
        !props.value?.status_lamp
      ) {
        return {
          element: (
            <>
              <Chip
                style={{
                  background: `${props.value?.color?.color}`,
                  color: '#fff',
                }}
                label={`${props.value?.name}`}
              />
            </>
          ),
          tooltipValue: props.value?.name,
        };
      }

      if (props.value?.icon === null && !props.value?.status_lamp) {
        const IconComponent = Icons[props.value?.name as keyof typeof Icons];
        return {
          element: (
            <>
              <Chip
                variant="outlined"
                style={{ color: '#666' }}
                icon={IconComponent ? <IconComponent /> : <></>}
                label={props.value?.name}
              />
            </>
          ),
          tooltipValue: props.value?.name,
        };
      }

      if (props.value?.status_lamp) {
        if (props.value?.icon) {
          const withDate = props?.field === 'service_reservation_status';

          let tooltipValue = props.value?.name;

          if (props.row?.status_log && props.row.status_log.length) {
            const statusLogs = [...(props?.row?.status_log ?? [])]
              .reverse()
              .map((item: any, index: number) => {
                return <span key={index}>{item}</span>;
              });

            tooltipValue = <Stack>{statusLogs}</Stack>;
          }
          if (
            props.row.status_log &&
            !props.row.status_log.length &&
            props.row?.service_reservation_status_updated_at
          ) {
            tooltipValue = `${tooltipValue} - ${props.row.service_reservation_status_updated_at}`;
          }

          if (props?.row?.status_messages) {
            const messages = props?.row?.status_messages.map(
              (item: any, index: number) => {
                return (
                  <span
                    key={index}
                    style={{
                      paddingLeft: `${(item?.tab || 0) * 20}px`,
                    }}
                  >
                    {item?.value}
                  </span>
                );
              }
            );

            tooltipValue = <Stack>{messages}</Stack>;
          }

          const IconComponent =
            Icons[props.value?.icon?.name as keyof typeof Icons];

          if (props.row?.warning_reasons && props.value?.id === 7) {
            tooltipValue = (
              <React.Fragment>
                {props.row?.warning_reasons.map((item: any) => {
                  return <p>{item}</p>;
                })}
              </React.Fragment>
            );
          }

          return {
            element: (
              <>
                <Avatar
                  sx={{
                    background: props.value?.color?.color,
                    width: 20,
                    height: 20,
                    '& .MuiSvgIcon-root': {
                      fontSize: '16px',
                    },
                  }}
                  onClick={() => {
                    console.log('adasdasdsasd');
                  }}
                >
                  {props.value?.icon && (
                    <>{IconComponent ? <IconComponent /> : null}</>
                  )}
                </Avatar>
              </>
            ),
            tooltipValue: tooltipValue,
          };
        }

        return {
          element: (
            <>
              <div
                className="fill-div h-full"
                style={{ background: `${props?.value?.color?.color}` }}
              ></div>
            </>
          ),
          tooltipValue: props?.value?.name,
        };
      } else {
        return {
          element: (
            <>
              <div className="overflow-hidden text-ellipsis whitespace-nowrap">
                <div
                  style={{
                    color: props?.value?.color?.color ? '#fff' : '',
                    background: `${props?.value?.color?.color}`,
                  }}
                >
                  {props.value?.name}
                </div>
              </div>
            </>
          ),
          tooltipValue: props.value?.name,
        };
      }
    }
  }, [props]);

  const [openDialog, setOpenDialog] = useState<any>(false);

  const handleOpen = () => {
    setOpenDialog(props?.row);
  };

  return (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Tooltip
        sx={{
          maxWidth: '700px',
          whiteSpace: 'pre-line',
        }}
        disableInteractive
        title={getFieldContent().tooltipValue}
        slotProps={{
          tooltip: {
            sx: {
              fontSize: '13px',
              maxWidth: '700px',
            },
          },
          popper: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, -14],
                },
              },
            ],
          },
        }}
      >
        <div
          onClick={() => {
            handleOpen();
          }}
        >
          {getFieldContent().element}
        </div>
      </Tooltip>
      {openDialog && (
        <ServiceStatusDialog
          row={openDialog}
          handleClose={() => {
            setOpenDialog(false);
          }}
        />
      )}
    </Stack>
  );
};
